/*
* Copyright Amazon.com, Inc. and its affiliates. All Rights Reserved.
* SPDX-License-Identifier: MIT
*
* Licensed under the MIT License. See the LICENSE accompanying this file
* for the specific language governing permissions and limitations under
* the License.
*/

import React, { useEffect } from 'react';
import { AmplifySignIn, AmplifyToast } from '@aws-amplify/ui-react';
import { I18n } from '@aws-amplify/core';
import { Translations } from "@aws-amplify/ui-components";
import { Auth } from "aws-amplify";
import * as Sentry from "@sentry/react";

const Login = ({ onError }) => {
	useEffect(() => {
		const dictLang = {
			[Translations.FORGOT_PASSWORD_TEXT]: " ",
			[Translations.RESET_PASSWORD_TEXT]: "Recupera password",
			[Translations.NO_ACCOUNT_TEXT]: "Non hai un account?",
			[Translations.CREATE_ACCOUNT_TEXT]: "Registrati",
			[Translations.DEFAULT_MSG]: "Errore di autenticazione",
			"Pending sign-in attempt already in progress": "Login in corso..."
		};
		I18n.putVocabulariesForLanguage("it", dictLang);
		I18n.putVocabulariesForLanguage("en", dictLang);
	}, [])
	return (
		<>
			<AmplifySignIn className="login login-form"
				headerText=''
				usernameAlias="email"
				slot="sign-in"
				submitButtonText='Login'
				handleSubmit={async (event) => {
					event.stopPropagation()
					event.preventDefault()
					onError && onError("")
					let migration_uri;
					const queryParams = new URLSearchParams(window.location.href)
					try {
						const migration_uri_param = queryParams?.get("migration_uri");
						migration_uri = migration_uri_param && new URL(migration_uri_param).origin;
					} catch (error) {
						Sentry.addBreadcrumb({
							category: "auth",
							message: `migration_uri: ${migration_uri}`,
							level: "info",
						});
						Sentry.captureException(error);
					}

					try {
						const email = event.target.email.value
						const password = event.target.password.value

						Sentry.addBreadcrumb({
							category: "auth",
							message: `login with user ${email}`,
							level: "info",
						});

						const query_param_redirect_uri = new URLSearchParams(window.location.href)?.get("redirect_uri");
						const redirect_uri = query_param_redirect_uri ? new URL(query_param_redirect_uri).origin : "";

						console.log("[signIn]", JSON.stringify({ email, queryParams, redirect_uri, migration_uri }))
						const responseSignIn = await Auth.signIn(email, password, { source: redirect_uri, migration_uri })
						if (responseSignIn?.challengeName === "NEW_PASSWORD_REQUIRED") {
							onError && onError("Il tuo utente è verificato ma è necessario eseguire il reset della password da parte di un amministratore")
						} else {
							// Login successfull
						}
					} catch (error) {
						Sentry.captureException(error);
						console.log("error", error?.message)
						if (error?.message?.includes("User not found") || error?.message?.includes("Incorrect username or password")) {
							onError("Credenziali non valide")
						} else if (error?.message?.includes("Password attempts exceeded")) {
							onError("Hai tentato di accedere troppe volte con una password o un account non corretto, resetta la password oppure contatta l'assistenza")
						} else if (error?.message?.includes("User is not confirmed")) {
							onError("L'utente non è stato ancora confermato, controlla la tua e-mail.")
						} else {
							onError(error?.message || "Errore durante l'accesso")
						}
					}


				}}
				formFields={[
					{
						type: "email",
						label: "Email *",
						placeholder: "Inserisci la tua e-mail",
						required: true,
						inputProps: {
							'data-test': 'sign-in-email-input',
						},
					},
					{
						type: "password",
						required: true,
						placeholder: "Inserisci la tua password",
						label: "Password *",
						inputProps: {
							'data-test': 'sign-in-password-input',
							// 'style': {color:"red"}
						},
					}
				]}>
				<div slot="federated-buttons"></div>
			</AmplifySignIn>


		</>

	);
}

export default Login;
